export default "__VITE_ASSET__5j7KIUzd__"